import React from "react";
import { useConfig } from "providers/ConfigProvider";
import PropTypes from "prop-types";
import PageMarkdown from "components/LegalPages/PageMarkdown";
import PageAccordion from "components/LegalPages/PageAccordion";

export default function LegalPage({ page, downloadUrl }) {
  const { isCustomerUrl, isPartnerUrl } = useConfig();

  const getSuffix = () => {
    if (isCustomerUrl) return "-client";
    if (isPartnerUrl) return "-partner";
    return "";
  };

  switch (page) {
    case "cgu":
      return (
        <PageMarkdown
          filename={`${page}${getSuffix()}.md`}
          downloadUrl={isCustomerUrl && downloadUrl}
          title="Conditions générales d'utilisation"
        />
      );
    case "cgv":
      return (
        <PageMarkdown
          filename={`${page}.md`}
          downloadUrl={isCustomerUrl && downloadUrl}
          title="Conditions générales de vente"
        />
      );
    case "faq":
      return <PageAccordion filename={`${page}.md`} title="F.A.Q." />;
    case "mention":
      return <PageMarkdown filename={`${page}.md`} title="Mentions légales" />;
    case "policy":
      return (
        <PageMarkdown
          filename={`${page}${getSuffix()}.md`}
          downloadUrl={isCustomerUrl && downloadUrl}
          title="Politique de confidentialité de la plateforme"
        />
      );
    default:
  }

  return null;
}
LegalPage.propTypes = {
  page: PropTypes.string.isRequired,
  downloadUrl: PropTypes.string,
};
